export class Model {
  code: string;
  commercialCode: string;
  name: string;
  group: any;
}
